import React from 'react'
import { useSelector } from 'react-redux'

// עמוד "מי נמדד" — 2.
const Slide2WhoMeasured = ({ data, activeCard, onShowTotals, onShowAffiliations }) => {
    const { brokenDisplay } = useSelector(state => state.general)
    const { totalStudents, executedStudents, elementarySchoolCount, middleSchoolCount, gradeCount, gradesLabel } = data

    const cards = [
        {
            key: 'total',
            value: totalStudents,
            label: 'תלמידים בתכנית המדידה',
            sub: executedStudents != null ? (
                <>{'בפועל ביצעו מבדקים '}<span className={`${brokenDisplay && 'blurred2'}`}>{executedStudents.toLocaleString()}</span>{' תלמידים'}</>
            ) : null,
            faIcon: 'fa-regular fa-users',
            onClick: onShowTotals
        },
        {
            key: 'grades',
            value: gradeCount,
            label: gradesLabel ? `שכבות גיל - ${gradesLabel}` : 'שכבות גיל',
            faIcon: 'fa-regular fa-child-reaching'
        },
        {
            key: 'elementary',
            value: elementarySchoolCount,
            label: 'בתי ספר יסודיים',
            faIcon: 'fa-regular fa-school',
            onClick: onShowAffiliations
        },
        {
            key: 'middle',
            value: middleSchoolCount,
            label: 'חטיבות ביניים',
            faIcon: 'fa-regular fa-user-graduate',
            onClick: onShowAffiliations
        },
    ]

    return (
        <div className='stat-cards'>
            {cards.map(({ key, value, label, sub, faIcon, onClick }) => (
                <div
                    key={key}
                    className={`stat-card ${onClick ? 'clickable' : ''} ${activeCard === key ? 'active' : ''}`}
                    onClick={onClick ? () => onClick(key) : undefined}
                >
                    <div className={`stat-value ${brokenDisplay && 'blurred10'}`}>{value != null ? value.toLocaleString() : '—'}</div>
                    <div className='stat-label'>
                        <i className={faIcon} />
                        {label}
                    </div>
                    {sub && <div className='stat-sub'>{sub}</div>}
                </div>
            ))}
        </div>
    )
}

export default Slide2WhoMeasured
